import { ComponentProps, ElementType } from "react";
import { ClauseInfoApp } from "../pages/ClauseInfoApp";
import { HomeApp } from "../pages/HomeApp";
import { SuggestionApp } from "../pages/SuggestionApp";
import { ApplicationType } from "../types/enums";

type ApplicationComponentType = { [P in keyof ApplicationType]: ApplicationType[P] };

type ApplicationTypeToken = ApplicationType.CLAUSE_INFO_APP | ApplicationType.HOME_APP | ApplicationType.SUGGESTION_APP;

type ComponentType<T extends ApplicationComponentType> = T extends ApplicationType.CLAUSE_INFO_APP
  ? ElementType<typeof ClauseInfoApp>
  : T extends ApplicationType.HOME_APP
    ? ElementType<typeof HomeApp>
    : T extends ApplicationType.SUGGESTION_APP
      ? ElementType<typeof SuggestionApp>
      : ElementType;

type GenericAppComponentType<C extends ElementType = ComponentType<ApplicationTypeToken>> = {
  as: C;
} & ComponentProps<C>;

export default function GenericAppComponent<T extends ApplicationComponentType>({
  as,
  children,
  ...props
}: GenericAppComponentType<ComponentType<T>>) {
  const Component = as || "div";

  return <Component {...props}>{children}</Component>;
}
